import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  TimePicker,
} from '@material-ui/pickers'

const useStyles = makeStyles(theme => ({
  picker: {
    '& label': {
      left: '35px',
      whiteSpace: 'nowrap',
    },
    '& input': {
      textAlign: 'center',
    },
  },
}))

const TimePickerUI = ({
  label = "Click to change the time",
  value,
  className,
  onChange,
}) => {

  const classes = useStyles()

  return (
    <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <TimePicker
        className={ className }
        label={ label }
        value={ value }
        onChange={ onChange }
      />
    </MuiPickersUtilsProvider>
  )
}

export default TimePickerUI